import { ROUND_PROVIDER, resolveProviderAssignment } from '@payments/shared/utils/roundPayments';

export default defineNuxtPlugin({
  name: 'payment-provider-override',
  dependsOn: ['pinia-persistence'],

  setup() {
    if (useAppConfig().roundOnly) {
      const override = resolveProviderAssignment(usePaymentProviderOverride());
      const roundAssignment = override?.provider === ROUND_PROVIDER ? override : resolveProviderAssignment(ROUND_PROVIDER);

      Object.assign(useKegelGatewayStore(), { ...roundAssignment, railLocked: true });
      return;
    }

    const assignment = resolveProviderAssignment(usePaymentProviderOverride(), !!useAppConfig().chargebeeOnly);

    if (!assignment) return;

    Object.assign(useKegelGatewayStore(), { ...assignment, providerResolved: true });
  },
});
